import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const slips = document.querySelectorAll('.js-slip-text');

if (slips) {
  slips.forEach(slip => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('js-slip-text__wrap');
    const clone = slip.cloneNode(true);
    const addClone = clone.cloneNode(true);
    const addClone2 = clone.cloneNode(true);

    // `c-text--white` クラスがあるかどうかを確認
    if (clone.classList.contains('c-text--white')) {
      addClone.classList.remove('c-text--white');
      addClone2.classList.remove('c-text--white');
    }

    addClone.classList.add('js-slip-text__item', 'js-slip-text__item--left');
    addClone2.classList.add('js-slip-text__item', 'js-slip-text__item--right');

    wrapper.appendChild(clone);
    wrapper.appendChild(addClone);
    wrapper.appendChild(addClone2);
    slip.after(wrapper);
    slip.remove();
  })
}